import { ProductVariation } from 'models/productsReferential';
import { useGetAssetTypesOptions } from 'routes/essential-workspace/components/product-selector/hooks/use-assets-types';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

type AssetTypePickerProps = {
  products: readonly ProductVariation[];
  onSelectAssetType: (assetType: string) => void;
};

export function AssetTypePicker({ products, onSelectAssetType }: AssetTypePickerProps) {
  const assetTypes = useGetAssetTypesOptions(products);

  const handleSelect = (asset: string) => {
    logAnalytics.trackEvent('Primary market essential product selector', 'Open asset shortcut', asset);
    onSelectAssetType(asset);
  };

  return (
    <div className="flex-x gap-2" role="group" aria-label="Asset types shortcuts">
      {assetTypes.map(({ value, label, icon }) => (
        <button
          key={value}
          type="button"
          onClick={() => handleSelect(value)}
          className="btn btn-lg btn-flat-secondary btn-icon-start"
          aria-haspopup="dialog"
        >
          <span className="icon icon-sm" aria-hidden="true">
            {icon}
          </span>
          {label}
        </button>
      ))}
    </div>
  );
}
